import React, { forwardRef } from "react";

/**
 * Shared auth-form text input: floating gold label above a pill input,
 * with optional left icon and right-side adornment (e.g. password toggle).
 */
const TextInput = forwardRef(function TextInput(
  { label, icon, endAdornment, className = "", ...props },
  ref,
) {
  return (
    <label className={`w-full text-left block ${className}`}>
      {label && (
        <span className="block text-white/70 font-semibold text-xs uppercase tracking-wide mb-1.5">
          {label}
        </span>
      )}
      <div className="relative group">
        {icon && (
          <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-brand-gold/80 text-lg pointer-events-none">
            {icon}
          </div>
        )}
        <input
          ref={ref}
          {...props}
          className={[
            "w-full rounded-xl py-3 text-white text-base bg-white/[0.04] border border-white/10",
            "outline-none transition-all duration-200 focus:bg-brand-purple/10 focus:border-brand-gold focus:shadow-[0_0_0_3px_rgba(239,191,4,0.15)]",
            "placeholder:text-white/35",
            icon ? "pl-11" : "pl-4",
            endAdornment ? "pr-11" : "pr-4",
          ].join(" ")}
        />
        {endAdornment && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2">{endAdornment}</div>
        )}
      </div>
    </label>
  );
});

export default TextInput;
